'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OldBrowsers = exports.Scroll = exports.Credits = exports.ContainerVideo = exports.CarouselModal = exports.Carousel = exports.ContainerCarousel = exports.CircleButton = exports.NextBtn = exports.Button = exports.RichLink = exports.LinksMapper = exports.Instructions = exports.VideoPlayer = exports.ComLabVideo = exports.ModalText = exports.Modal = exports.Loading = exports.SoundMuted = exports.ComLabRRSS = exports.Cover = exports.HeaderMenu = exports.Header = exports.Footer = undefined;

var _Footer2 = require('./Layout/Footer/Footer');

var _Footer3 = _interopRequireDefault(_Footer2);

var _Header2 = require('./Layout/Header/Header');

var _Header3 = _interopRequireDefault(_Header2);

var _HeaderMenu2 = require('./Layout/Header/HeaderMenu');

var _HeaderMenu3 = _interopRequireDefault(_HeaderMenu2);

var _Cover2 = require('./Layout/Cover/Cover');

var _Cover3 = _interopRequireDefault(_Cover2);

var _ComLabRRSS2 = require('./ComLabRRSS/ComLabRRSS');

var _ComLabRRSS3 = _interopRequireDefault(_ComLabRRSS2);

var _SoundMuted2 = require('./SoundMuted/SoundMuted');

var _SoundMuted3 = _interopRequireDefault(_SoundMuted2);

var _Loading2 = require('./Loading/Loading');

var _Loading3 = _interopRequireDefault(_Loading2);

var _Modal2 = require('./Modal/Modal');

var _Modal3 = _interopRequireDefault(_Modal2);

var _ModalText2 = require('./Modal/ModalText');

var _ModalText3 = _interopRequireDefault(_ModalText2);

var _ComLabVideo2 = require('./ComLabVideo/ComLabVideo');

var _ComLabVideo3 = _interopRequireDefault(_ComLabVideo2);

var _VideoPlayer2 = require('./VideoPlayer/VideoPlayer');

var _VideoPlayer3 = _interopRequireDefault(_VideoPlayer2);

var _Instructions2 = require('./Instructions/Instructions');

var _Instructions3 = _interopRequireDefault(_Instructions2);

var _LinksMapper2 = require('./common/Links/LinksMapper');

var _LinksMapper3 = _interopRequireDefault(_LinksMapper2);

var _RichLink2 = require('./common/Links/RichLink');

var _RichLink3 = _interopRequireDefault(_RichLink2);

var _Button2 = require('./common/Buttons/Button');

var _Button3 = _interopRequireDefault(_Button2);

var _NextBtn2 = require('./common/Buttons/NextBtn');

var _NextBtn3 = _interopRequireDefault(_NextBtn2);

var _CircleButton2 = require('./common/Buttons/CircleButton');

var _CircleButton3 = _interopRequireDefault(_CircleButton2);

var _ContainerCarousel2 = require('./ContainerCarousel/ContainerCarousel');

var _ContainerCarousel3 = _interopRequireDefault(_ContainerCarousel2);

var _Carousel2 = require('./Carousel/Carousel');

var _Carousel3 = _interopRequireDefault(_Carousel2);

var _CarouselModal2 = require('./Carousel/CarouselModal');

var _CarouselModal3 = _interopRequireDefault(_CarouselModal2);

var _ContainerVideo2 = require('./ContainerVideo/ContainerVideo');

var _ContainerVideo3 = _interopRequireDefault(_ContainerVideo2);

var _Credits2 = require('./Credits/Credits');

var _Credits3 = _interopRequireDefault(_Credits2);

var _Scroll2 = require('./Scroll/Scroll');

var _Scroll3 = _interopRequireDefault(_Scroll2);

var _OldBrowsers2 = require('./OldBrowsers/OldBrowsers');

var _OldBrowsers3 = _interopRequireDefault(_OldBrowsers2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Footer = _Footer3.default; /**
                                    *  Point of contact for component modules
                                    *
                                    *  ie: import { CounterButton, InfoBar } from 'components';
                                    *
                                    */

//Layout

exports.Header = _Header3.default;
exports.HeaderMenu = _HeaderMenu3.default;
exports.Cover = _Cover3.default;
// export InformationalPage from './InformationalPage/InformationalPage'

//RRSS

exports.ComLabRRSS = _ComLabRRSS3.default;

//SoundMuted

exports.SoundMuted = _SoundMuted3.default;

//Loading

exports.Loading = _Loading3.default;

//Modal

exports.Modal = _Modal3.default;
exports.ModalText = _ModalText3.default;

//Media

exports.ComLabVideo = _ComLabVideo3.default;
exports.VideoPlayer = _VideoPlayer3.default;

//Intro

exports.Instructions = _Instructions3.default;

/*COMMON*/

exports.LinksMapper = _LinksMapper3.default;
exports.RichLink = _RichLink3.default;
exports.Button = _Button3.default;
exports.NextBtn = _NextBtn3.default;
exports.CircleButton = _CircleButton3.default;

//Carousel

exports.ContainerCarousel = _ContainerCarousel3.default;
exports.Carousel = _Carousel3.default;
exports.CarouselModal = _CarouselModal3.default;
exports.ContainerVideo = _ContainerVideo3.default;

// Credits

exports.Credits = _Credits3.default;
//Scroll

exports.Scroll = _Scroll3.default;

//OldBrowsers

exports.OldBrowsers = _OldBrowsers3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/index.js
// module id = 33
// module chunks = 0